import React from "react";

import "./CloseButton.scss";

const CloseButton = ({ onClick }) => (
    <div className="close" onClick={onClick}></div>
);

export default CloseButton;
